import { IRemoteStorageService } from "common/api/remoteStorage.service";
import { Deferred } from "common/helpers/deferred";
import { Nullable } from "common/types";

const WAIT_TIMEOUT = 15_000;

let service: Nullable<IRemoteStorageService> = null;
let waiters: Array<Deferred<IRemoteStorageService>> = [];

export const setRemoteStorage = (next: Nullable<IRemoteStorageService>): void => {
  service = next;
  if (!next) return;

  const pending = waiters;
  waiters = [];
  pending.forEach((waiter) => waiter.resolve(next));
};

export const clearRemoteStorage = (published: IRemoteStorageService): void => {
  if (service === published) service = null;
};

export const getRemoteStorage = (): Nullable<IRemoteStorageService> => service;

/**
 * Resolves once the service has been published, so a call made before the provider mounts waits
 * rather than failing.
 *
 * @param timeout
 * @returns
 */
export const whenRemoteStorage = (timeout = WAIT_TIMEOUT): Promise<IRemoteStorageService> => {
  if (service) return Promise.resolve(service);

  const waiter = Deferred.defer<IRemoteStorageService>();

  const timer = setTimeout(() => {
    waiters = waiters.filter((pending) => pending !== waiter);
    waiter.reject(new Error("Timed out waiting for the messages service to become available"));
  }, timeout);

  waiters.push(waiter);

  return waiter.promise.finally(() => clearTimeout(timer));
};

/** Exported for tests — module state would otherwise leak between cases. */
export const resetRemoteStorageWaiters = (): void => {
  waiters = [];
};
